import { BaseApi } from '@/main/baseApi';

import {
	DMS_MODULE,
	NAME,
} from './constants';

class ZakazkaZapujckaProvider extends BaseApi {
	zakazkapaKontrola(params: Record<string, any>) {
		return this.fetch(`/${DMS_MODULE}/${NAME}/ZakazkapaKontrola`, params);
	}
}

export const apiProvider = new ZakazkaZapujckaProvider(DMS_MODULE, NAME);
